import { render, staticRenderFns } from "./RevenueIcon.vue?vue&type=template&id=470d3a72&"
import script from "./RevenueIcon.vue?vue&type=script&lang=js&"
export * from "./RevenueIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports